import { render, staticRenderFns } from "./SideNavContextSelect.vue?vue&type=template&id=b3effb0e"
import script from "./SideNavContextSelect.vue?vue&type=script&lang=js"
export * from "./SideNavContextSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports